// import axios from 'axios';
const axios = require('axios').default;
import { Login, User, Address, Controller, Counter, ControllerLog,
  EmailSubscription, MosruSubscription, MosruCounter, PasswordUpdate,
  ControllerEvent, SupportRequest, CounterValue, ManagementCompanyWithReports,
  CounterTicks, HistoryValues,
  } from './models';
import store from './store';
import { formatDate } from './common';

export interface Status {
  rc: number;
  msg: string;
}

async function makeCallApiWithoutBaseURL(method: string, url: string, data: null | {} = null) {
  const jwt = store.getters.jwt;
  return axios({method, url, data,
    headers: {'X-Auth-Token': jwt.auth, 'X-Refresh-Token': jwt.refresh, 'X-Csrf-Token': jwt.csrf},
  });
}

// export function setJWT(auth: string, refresh: string, csrf: string) {
//   makeCallApiWithoutBaseURL('headers', = {
//     'x-auth-token': auth,
//     'x-refresh-token': refresh,
//     'x-csrf-token': csrf,
//   };
//   console.log(makeCallApiWithoutBaseURL('headers', ;
// }

// export function clearJWT() {
//   makeCallApiWithoutBaseURL('headers', = {};
// }

// function restoreJWT() {
//   let jwt = store.getters.jwt;
//   setJWT(jwt.auth, jwt.refresh, jwt.csrf);
// }

export async function loginUser(user: Login): Promise<User> {
  store.commit('clearJWT');
  const response = await makeCallApiWithoutBaseURL('post', '/api/v2/service/authentication/login', {
    username: user.username,
    password: user.password,
    clear_password: true,
  });
  // setJWT(response.headers['x-auth-token'], response.headers['x-refresh-token'], response.headers['x-csrf-token']);
  store.commit('setJWT', {
    auth: response.headers['x-auth-token'],
    refresh: response.headers['x-refresh-token'],
    csrf: response.headers['x-csrf-token'],
  });
  // console.log(response.headers);
  return (response.data as User);
}

export async function updatePassword(pass: PasswordUpdate): Promise<User> {
  const response = await makeCallApiWithoutBaseURL('post', '/api/v2/service/authentication/password/update', {
    username: pass.username,
    old_password: pass.oldPassword,
    new_password: pass.newPassword,
    clear_password: true,
  });
  return (response.data as User);
}

export async function resetPassword(email: string): Promise<boolean> {
  await makeCallApiWithoutBaseURL('post', `/api/v2/service/authentication/password/reset`, {email});
  return true;
}

export async function checkPasswordResetToken(email: string, token: string): Promise<boolean> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/authentication/password/reset/checktoken`, {email, token});
  return response.status === 200;
}

export async function setNewPassword(email: string, token: string, password: string): Promise<boolean> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/authentication/password/set`, {
    email: email,
    token: token,
    password: password,
  });
  return response.status === 200;
}

export async function updateProfile(user: User): Promise<User> {
  const response = await makeCallApiWithoutBaseURL('patch', `/api/v2/service/grpc/user/${user.id}`, user);
  return (response.data as { profile: User }).profile;
}

export async function getAddresses(uid: number): Promise<Address[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/addresses`);
  return (response.data as { addresses: Address[] }).addresses;
}

export async function addAddress(uid: number, addr: Address): Promise<Address> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/grpc/user/${uid}/address`, addr);
  return (response.data as { address: Address }).address;
}

export async function saveAddress(uid: number, addr: Address): Promise<Address> {
  const response = await makeCallApiWithoutBaseURL('put', `/api/v2/service/grpc/user/${uid}/address/${addr.id}`, addr);
  return (response.data as { address: Address }).address;
}

export async function removeAddress(uid: number, addrId: number): Promise<number> {
  const response = await makeCallApiWithoutBaseURL('delete', `/api/v2/service/grpc/user/${uid}/address/${addrId}`);
  return addrId;
}

export async function getControllers(uid: number): Promise<Controller[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controllers`);
  return (response.data as { controllers: Controller[] }).controllers;
}

export async function getControllerLog(uid: number, addrId: number): Promise<ControllerLog> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${addrId}/log`);
  return (response.data as { log: ControllerLog }).log;
}

export async function getControllerCounters(uid: number, id: number): Promise<{id: number, counters: Counter[]}> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${id}/counters`);
  return { id, counters: (response.data as { counters: Counter[] }).counters};
}

export async function getMCsWithReports(uid: number, onDate?: Date): Promise<ManagementCompanyWithReports[]> {
  const onDateArg = (onDate == null) ? '' : ('?ondate=' + formatDate(onDate, 'yyyy-mm-dd'));
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/mcs/controllers/fullinfo` + onDateArg);
  const data = response.data as { mcs: ManagementCompanyWithReports[] };
  return data.mcs;
}

// export async function getCounterLog(id: number): Promise<CounterLog> {
// restoreJWT();
//   const response = await Api.get(`/api/v2/service/grpc/counter/${id}/log`);
//   return (response.data as { log: CounterLog }).log;
// }

export async function getControllerEmailSubscriptions(uid: number, controllerId: number): Promise<{controllerId: number, subscriptions: EmailSubscription[]}> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/subscriptions/email`);
  if ((response.data as { status: Status }).status.rc !== 1) { throw Error('Error rc'); }
  if (response.data.hasOwnProperty('subscriptions')) {
    return { controllerId, subscriptions: (response.data as { subscriptions: EmailSubscription[] }).subscriptions };
  } else {
    return { controllerId, subscriptions: [] };
  }
}

export async function getControllerMosruSubscriptions(uid: number, controllerId: number): Promise<{controllerId: number, subscriptions: MosruSubscription[]}> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/subscriptions/mosru`);
  if ((response.data as { status: Status }).status.rc !== 1) { throw Error('Error rc'); }
  if (response.data.hasOwnProperty('subscriptions')) {
    return { controllerId, subscriptions: (response.data as { subscriptions: MosruSubscription[] }).subscriptions };
  } else {
    return { controllerId, subscriptions: [] };
  }
}

export async function addEmailSubscription(uid: number, subscrp: EmailSubscription): Promise<{controllerId: number, subscription: EmailSubscription}> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/grpc/user/${uid}/controller/${subscrp.controllerId}/subscription/email`, subscrp);
  return {controllerId: subscrp.controllerId, subscription: (response.data as { subscription: EmailSubscription }).subscription};
}

export async function saveEmailSubscription(uid: number, subscrp: EmailSubscription): Promise<{controllerId: number, subscription: EmailSubscription}> {
  const response = await makeCallApiWithoutBaseURL('put', `/api/v2/service/grpc/user/${uid}/controller/${subscrp.controllerId}/subscription/email/${subscrp.id}`, subscrp);
  return {controllerId: subscrp.controllerId, subscription: (response.data as { subscription: EmailSubscription }).subscription};
}

export async function removeEmailSubscription(uid: number, controllerId: number, id: number): Promise<{id: number, controllerId: number}> {
  const response = await makeCallApiWithoutBaseURL('delete', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/subscription/email/${id}`);
  return {controllerId, id};
}

export async function getMosruCounters(uid: number, controllerId: number): Promise<{controllerId: number, counters: MosruCounter[]}> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/mosrucounters`);
  return {controllerId, counters: (response.data as { mosruCounters: MosruCounter[] }).mosruCounters};
}

export async function addMosruSubscription(uid: number, controllerId: number, subscrp: MosruSubscription): Promise<{controllerId: number, subscription: MosruSubscription}> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/subscription/mosru`, subscrp);
  return {controllerId, subscription: (response.data as { subscription: MosruSubscription }).subscription};
}

export async function removeMosruSubscription(uid: number, controllerId: number, id: number): Promise<{id: number, controllerId: number}> {
  const response = await makeCallApiWithoutBaseURL('delete', `/api/v2/service/grpc/user/${uid}/controller/${controllerId}/subscription/mosru/${id}`);
  return {id, controllerId};
}

export async function getControllerEvents(uid: number, seen: number): Promise<ControllerEvent[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controllerevents?unseen=${seen}`);
  return (response.data as { controllerEvents: ControllerEvent[] }).controllerEvents;
}

export async function getNotifications(uid: number, seen: number): Promise<Notification[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/notifications?unseen=${seen}`);
  return (response.data as { notifications: Notification[] }).notifications;
}

export async function getSupportRequests(uid: number): Promise<SupportRequest[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/support/requests`);
  return (response.data as { requests: SupportRequest[] }).requests;
}

export async function sendSupportRequest(uid: number, req: SupportRequest): Promise<SupportRequest> {
  const response = await makeCallApiWithoutBaseURL('post', `/api/v2/service/grpc/user/${uid}/support/requests`, {request: req});
  return (response.data as { request: SupportRequest }).request;
}

// export async function getCounterValues(uid: number): Promise<CounterValue[]> {
//
//   const response = await Api.get(`/api/v2/service/grpc/user/${uid}/counters/values`);
//   return (response.data as { values: CounterValue[] }).values;
// }

export async function getCounterValuesByControllerID(uid: number, id: number): Promise<CounterValue[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${id}/counters/values?type=1`);
  return (response.data as { values: CounterValue[] }).values;
}

export async function getCounterValuesOnDate(uid: number, id: number, date: string): Promise<CounterValue[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${id}/counters/values?type=2&ondate=${date}`);
  return (response.data as { values: CounterValue[] }).values;
}

export async function getCounterValuesOnPeriod(uid: number, id: number, datefrom: string, dateto: string): Promise<CounterValue[]> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v2/service/grpc/user/${uid}/controller/${id}/counters/values?type=3&period=${datefrom},${dateto}`);
  return (response.data as { values: CounterValue[] }).values;
}

export async function getCountersTicks(uid: number, ctrlid: number, datefrom: string, dateto: string): Promise<CounterTicks[]> {
  let addUrlStr: string = '';
  if (datefrom.length > 0) {
    addUrlStr += '&df=' + datefrom;
  }
  if (dateto.length > 0) {
    addUrlStr += '&dt=' + dateto;
  }
  if (ctrlid > 0) {
    addUrlStr += `&ctrlid=${ctrlid}`;
  }
  const response = await makeCallApiWithoutBaseURL('get', `/api/v3/service/rest/ticks?userid=${uid}${addUrlStr}`);
  return (response.data as { counters: CounterTicks[] }).counters;
}

export async function getHistoryValues(uid: number, ctrlid: number): Promise<HistoryValues> {
  const response = await makeCallApiWithoutBaseURL('get', `/api/v3/service/rest/history/values?ctrlid=${ctrlid}&userid=${uid}`);
  const dates: number[] = (response.data as { Dates: number[] }).Dates;
  const values: {} = (response.data as { Values: {} }).Values;
  return {dates, values} as HistoryValues;
}

